<template>
  <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
  >

    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
      <el-row class="mt20">
        <el-col :span="24">
          <el-form-item prop="idCard" class="pass-form" label="法人身份证号">
            <el-input v-model="form.idCard"
                      placeholder="请补全身份证号">
              <template slot="prepend">{{ form.prefix }}</template>
              <template slot="append">{{ form.suffix }}</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button class="sub-button" type="primary" @click="handleSubmit">确 认</el-button>
      </span>
  </el-dialog>
</template>

<script>

export default {
  name: "idCardComplete",
  data() {
    var validIdCard = (rule, value, callback) => {
      let reg = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/;
      let idCard = this.form.prefix + value + this.form.suffix
      if (value === "") {
        callback(new Error("请输入法人身份证号"));
      } else if (!reg.test(idCard) && !this.disbaleList) {
        callback(new Error("请输入正确的法人身份证号"));
      } else {
        callback();
      }
    };

    return {
      dialogVisible: false,
      title: "",
      form: {
        // 后四位
        suffix: '',
        // 前四位
        prefix: ''
      },
      rules: {
        idCard: [{required: true, validator: validIdCard, trigger: "blur"}],
      },
    };
  },
  methods:{
    handleSubmit(){
      this.$refs.ruleForm.validate((value) => {
        if (value) {
          this.$emit('faceRecognition' , this.form.prefix + this.form.idCard + this.form.suffix)
          this.handleClose(false)
        }
      });
    },
    show(e){
      this.title = "法人身份证补全"
      this.form.prefix = e.substring(0, 4)
      this.form.suffix = e.slice(-4)
      this.dialogVisible = true
    },
    handleClose(done) {
      this.dialogVisible = false;
      this.form = {}
    }
  }
}
</script>

<style scoped lang="less">

</style>
